import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import JournalTable from './journalTable.component';
import CalculationLog from './calculationLog.component';
import withPillNavigation from '../../shared/withPillNavigation.decorator';
import JournalPillTypes from './journalPillTypes';

const JournalPillDefinitions = [
  { label: 'Journals', type: JournalPillTypes.JOURNAL },
  { label: 'Local Journals', type: JournalPillTypes.LOCAL_JOURNAL },
  { label: 'Journals Detail', type: JournalPillTypes.JOURNALS_DETAIL },
  { label: 'Calculation Log', type: JournalPillTypes.CALCUATION_LOG },
];

class JournalTab extends PureComponent {
  static propTypes = {
    activePill: PropTypes.oneOf(Object.values(JournalPillTypes)).isRequired,
  };

  render() {
    const { activePill } = this.props;

    return (
      <div className="journal-tab">
        {activePill !== JournalPillTypes.CALCUATION_LOG
          ? <JournalTable activePill={activePill} />
          : <CalculationLog />
        }
      </div>
    );
  }
}

export default withPillNavigation(
  ({ chartName }) => chartName === 'R2R'
    ? JournalPillDefinitions.filter(definition => definition.type !== JournalPillTypes.LOCAL_JOURNAL)
    : JournalPillDefinitions,
  {
    propTypes: {
      chartName: PropTypes.string.isRequired,
    },
  }
)(JournalTab);
